/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabasePasswordField
 */
export interface DatabasePasswordField extends DatabaseField {
    /**
     * 
     * @type {boolean}
     * @memberof DatabasePasswordField
     */
    revealInList?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabasePasswordField
     */
    revealInDetails?: boolean;
    /**
     * Optionale Vorgabe fuer das Passwort-/Token-Feld. Legt Format und
     * (per „Generieren"-Knopf) die Erzeugung des Wertes fest. Rein
     * additiv/optional; leer oder NONE = klassisches Freitext-Passwort.
     * Erweiterbar um weitere Passwortregeln.
     * Erlaubte Werte:
     *   - NONE          : freies Passwort (Default)
     *   - TOKEN_8_UPPER : 8-stelliger Token, nur Grossbuchstaben A–Z
     * @type {string}
     * @memberof DatabasePasswordField
     */
    valuePreset?: string;
}

/**
 * Check if a given object implements the DatabasePasswordField interface.
 */
export function instanceOfDatabasePasswordField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePasswordFieldFromJSON(json: any): DatabasePasswordField {
    return DatabasePasswordFieldFromJSONTyped(json, false);
}

export function DatabasePasswordFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePasswordField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'revealInList': !exists(json, 'revealInList') ? undefined : json['revealInList'],
        'revealInDetails': !exists(json, 'revealInDetails') ? undefined : json['revealInDetails'],
        'valuePreset': !exists(json, 'valuePreset') ? undefined : json['valuePreset'],
    };
}

export function DatabasePasswordFieldToJSON(value?: DatabasePasswordField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'revealInList': value.revealInList,
        'revealInDetails': value.revealInDetails,
        'valuePreset': value.valuePreset,
    };
}

